import React from "react"
import { Row, Col, Breadcrumb } from "react-bootstrap"

type BreadcrumbItems = {
  label: string
  path?: string
  active?: boolean
}

type PageTitleProps = {
  breadCrumbItems?: Array<BreadcrumbItems>
  title: string
}

const PageTitle = ({ breadCrumbItems, title }: PageTitleProps) => {
  return (
    <Row>
      <Col>
        <div className="page-title-box">
          <div className="page-title-right">
            <Breadcrumb listProps={{ className: "m-0" }}>
              {breadCrumbItems?.map((item, label_index) => {
                return (
                  <Breadcrumb.Item
                    active={item.active}
                    key={`${item?.label}_${label_index}`}
                    href={item.path}
                  >
                    {item.label}
                  </Breadcrumb.Item>
                )
              })}
            </Breadcrumb>
          </div>
          <h4 className="page-title">{title}</h4>
        </div>
      </Col>
    </Row>
  )
}

export default PageTitle
